import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Course } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get draft version of the course
 * @param course_id
 */
const getDraftCourse = (course_id: string | string[]): Promise<Course> => {
  return new Promise((resolve, reject) => {
    const URL = routes.COURSE + course_id + '/draft'
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.get(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getDraftCourse
